(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lwl-header"] && !Shopify.designMode) return;
  try {
    
  /* Overlay toggle, the mobile category select, and the --header-height custom
     properties that layout/theme.liquid would normally set from Horizon's
     <header-component>. Because this section replaces that element, the inline
     script there returns early, so we publish them ourselves. */
  class LwlHeader extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.lwl-menu-button');
      this.overlay = this.querySelector('.lwl-overlay');
      if (!this.button || !this.overlay) return;

      this.setAttribute('data-open', 'false');

      this.onToggle = () => this.toggle();
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.getAttribute('data-open') === 'true') this.close();
      };

      this.button.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);

      /* Only now does the select become a real control, so only now is the
         link row allowed to hide. The CSS keys off this attribute. */
      this.categorySelect = this.querySelector('.lwl-shopbar__select');
      if (this.categorySelect) {
        this.onCategoryChange = (event) => {
          const url = event.target.value;
          if (url) window.location.assign(url);
        };
        this.categorySelect.addEventListener('change', this.onCategoryChange);
        this.setAttribute('data-cat-select', 'on');
      }

      this.publishHeights();
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.publishHeights());
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onToggle);
      if (this.categorySelect) this.categorySelect.removeEventListener('change', this.onCategoryChange);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    /* Measure the chrome only, never the open overlay, or the curtain would
       feed its own height back in through the ResizeObserver. */
    publishHeights() {
      const bar = this.querySelector('.lwl-header__bar');
      const shopbar = this.querySelector('.lwl-shopbar');
      const barHeight = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      const shopHeight = shopbar ? Math.round(shopbar.getBoundingClientRect().height) : 0;
      const total = barHeight + shopHeight;
      this.style.setProperty('--lwl-header-h', total + 'px');
      document.body.style.setProperty('--header-height', barHeight + 'px');
      document.body.style.setProperty('--header-group-height', total + 'px');
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }

    toggle() {
      if (this.getAttribute('data-open') === 'true') {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.setAttribute('data-open', 'true');
      this.button.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.setAttribute('data-open', 'false');
      this.button.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
  }

  if (!customElements.get('lwl-header')) {
    customElements.define('lwl-header', LwlHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
